import { render, staticRenderFns } from "./AuthTel.vue?vue&type=template&id=29d083a6&scoped=true"
import script from "./AuthTel.vue?vue&type=script&lang=js"
export * from "./AuthTel.vue?vue&type=script&lang=js"
import style0 from "./AuthTel.vue?vue&type=style&index=0&id=29d083a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d083a6",
  null
  
)

export default component.exports